(function () {
    'use strict';

    angular.module('NaviaqWebApp').factory('dialogService', dialogService);

    dialogService.$inject = [];

    function dialogService() {
        var service = {
            openInformationModalDialog: openInformationModalDialog,
        };

        return service;

        function openInformationModalDialog(content, title=null) {
            return new Promise((resolve) => {
                const popupContainer = dxjQuery(`
                    <div>
                `).appendTo('body');
        
                popupContainer.dxPopup({
                    width: 400,
                    height: 'auto',
                    contentTemplate: function (contentElement) {
                        dxjQuery('<div>')
                        .css('text-align', 'center')
                        .text(content)
                        .appendTo(contentElement);
                    },
                    toolbarItems: [{
                        widget: 'dxButton',
                        toolbar: 'bottom',
                        location: 'center',
                        options: {
                            text: 'OK',
                            onClick: function () {
                                popupContainer.dxPopup('instance').hide();
                                resolve();
                            }
                        }
                    }],
                    showTitle: !!title,
                    title: title || '',
                    dragEnabled: false,
                    shading: true,
                    shadingColor: 'rgba(0, 0, 0, 0.5)',
                    hideOnOutsideClick: false,
                    showCloseButton: false,
                    visible: true,
                    onHidden: function () {
                        popupContainer.remove();
                    }
                });
            });
        }
    }
})();
